<template>
  <div>
    <Row :gutter="20" shadow>
      <i-col :md="12">
        <Divider orientation="left">收入明细</Divider>
        <Row :gutter="20" shadow style="padding-left: 40px;padding-top: 20px">
          <i-col :md="6" style="height: 120px;padding-bottom: 10px;">
            <h3>月均转账收入
              <InfoPopTip content="统计口径:所有收入中的转账类型,合计/账单月份"/>
            </h3>
            <h2>¥{{ homeStat.incoming.transfer.monthAvg }}元</h2>
            <span>笔均:¥{{ homeStat.incoming.transfer.billAvg }}元</span>
          </i-col>
          <i-col :md="6" style="height: 120px;padding-bottom: 10px;">
            <h3>月均工资
              <InfoPopTip content="交易备注包括工资以及相关字段,合计工资除以累计的月份,不保证连续性"/>
            </h3>
            <h2>¥{{ homeStat.incoming.wages.monthAvg }}元</h2>
            <span>累计月份:{{ homeStat.incoming.wages.countData }}</span>
          </i-col>
          <i-col :md="6" style="height: 120px;padding-bottom: 10px;">
            <h3>月均收单
              <InfoPopTip content="交易备注包括收单以及相关字段,合计收单除以累计的月份,不保证连续性"/>
            </h3>
            <h2>¥{{ homeStat.incoming.posTrade.monthAvg }}元</h2>
            <span>累计月份:{{ homeStat.incoming.posTrade.countData }}</span>
          </i-col>
          <i-col :md="6" style="height: 120px;padding-bottom: 10px;">
            <h3>其他收入
              <InfoPopTip content="剔除转账/工资/收单的其他收入月均"/>
            </h3>
            <h2>¥{{ homeStat.incoming.other.monthAvg }}元</h2>
          </i-col>
        </Row>
        <Divider orientation="left">支出明细</Divider>
        <Row :gutter="20" shadow style="padding-left: 40px;padding-top: 20px">
          <i-col :md="6" style="height: 120px;padding-bottom: 10px;">
            <h3>月均转账支出
              <InfoPopTip content="统计口径:所有支出中的转账类型,合计/账单月份"/>
            </h3>
            <h2>${{ homeStat.payout.transfer.monthAvg }}元</h2>
            <span>笔均:¥{{ homeStat.payout.transfer.billAvg }}元</span>
          </i-col>
          <i-col :md="6" style="height: 120px;padding-bottom: 10px;" v-if="homeStat.payout.other">
            <h3>月均日常消费
              <InfoPopTip content="统计口径:消费中剔除其他主要支出后的所有支出"/>
            </h3>
            <h2>${{ homeStat.payout.other.monthAvg }}元</h2>
            <span>笔均:{{ homeStat.payout.other.dayAvg }}</span>
          </i-col>
          <i-col :md="6" style="height: 120px;padding-bottom: 10px;" v-if="homeStat.payout.buy">
            <h3>月均购物消费
              <InfoPopTip content="统计口径:消费中电商/超市等购物相关信息的所有支出"/>
            </h3>
            <h2>¥{{ homeStat.payout.buy.monthAvg }}元</h2>
            <span>笔均:{{ homeStat.payout.buy.dayAvg }}</span>
          </i-col>
          <i-col :md="6" style="height: 120px;padding-bottom: 10px;" v-if="homeStat.payout.car">
            <h3>月均出行消费
              <InfoPopTip content="统计口径:消费中旅行/飞机/酒店/滴滴等出行相关信息的所有支出"/>
            </h3>
            <h2>¥{{ homeStat.payout.car.monthAvg }}元</h2>
            <span>笔均:{{ homeStat.payout.car.dayAvg }}</span>
          </i-col>
          <i-col :md="6" style="height: 120px;padding-bottom: 10px;" v-if="homeStat.payout.phone">
            <h3>月均话费支出
              <InfoPopTip content="统计口径:消费中话费相关信息的所有支出"/>
            </h3>
            <h2>¥{{ homeStat.payout.phone.monthAvg }}元</h2>
            <span>笔均:{{ homeStat.payout.phone.dayAvg }}</span>
          </i-col>
          <i-col :md="6" style="height: 120px;padding-bottom: 10px;" v-if="homeStat.payout.sdm">
            <h3>月均水电煤支出
              <InfoPopTip content="统计口径:消费中水费/电费/煤气费/暖气费相关信息的所有支出"/>
            </h3>
            <h2>¥{{ homeStat.payout.sdm.monthAvg }}元</h2>
            <span>笔均:{{ homeStat.payout.sdm.dayAvg }}</span>
          </i-col>
        </Row>
        <Divider orientation="left">特殊交易数据</Divider>
        <Row :gutter="20" shadow style="padding-left: 40px;padding-top: 20px">
          <i-col :md="6" style="height: 120px;padding-bottom: 10px;" v-if="homeStat.payout.luxury">
            <h3>高端消费总额
              <InfoPopTip content="统计口径:消费中黄金/珠宝/机票/奢侈品/高端酒店等相关信息的所有支出且金额大于1000"/>
            </h3>
            <h2>¥{{ homeStat.payout.luxury.money }}元</h2>
            <span>消费次数:{{ homeStat.payout.luxury.countData }}</span>
          </i-col>
          <i-col :md="6" style="height: 120px;padding-bottom: 10px;" v-if="homeStat.payout.manageMoney">
            <h3>理财数据
              <InfoPopTip content="统计口径:理财关联相关信息的所有"/>
            </h3>
            <h2>¥{{ homeStat.payout.manageMoney.money }}元</h2>
            <span>交易次数:{{ homeStat.payout.manageMoney.countData }}</span>
          </i-col>
        </Row>
        <Divider orientation="left">黑灰交易数据</Divider>
        <Row :gutter="20" shadow style="padding-left: 40px;padding-top: 20px">
          <i-col :md="6" style="height: 120px;padding-bottom: 10px;" v-if="homeStat.blackTrade.judicialFreeze">
            <h3>司法冻结\解冻
              <InfoPopTip content="交易备注含有司法冻结和司法解冻"/>
            </h3>
            <h2>¥{{ homeStat.blackTrade.judicialFreeze.money }}元
              <Icon type="ios-alert" color="red" v-if="homeStat.blackTrade.judicialFreeze.money > 0"/>
            </h2>
            <span>冻结次数:{{ homeStat.blackTrade.judicialFreeze.countData }}</span>
          </i-col>
          <i-col :md="6" style="height: 120px;padding-bottom: 10px;" v-if="homeStat.blackTrade.leisureEntertainment">
            <h3>娱乐交易
              <InfoPopTip
                content="统计口径:消费中KTV/会所等相关信息的所有支出且金额大于500,辅助判断客户是否存在黄赌毒情况"/>
            </h3>
            <h2>¥{{ homeStat.blackTrade.leisureEntertainment.money }}元</h2>
            <span>次数:{{
                homeStat.blackTrade.leisureEntertainment.countData
              }},笔均:{{ homeStat.blackTrade.leisureEntertainment.dayAvg }}</span>
          </i-col>
          <i-col :md="6" style="height: 120px;padding-bottom: 10px;" v-if="homeStat.blackTrade.highFrequencyTransfer">
            <h3>高频转账
              <InfoPopTip content="统计口径:周期内转账超过五次的人数和天数,辅助判断客户是否存在关联交易和赌博情况"/>
            </h3>
            <h2>¥{{ homeStat.blackTrade.highFrequencyTransfer.money }}元</h2>
            <span>人数:{{
                homeStat.blackTrade.highFrequencyTransfer.monthAvg
              }},天数:{{ homeStat.blackTrade.highFrequencyTransfer.dayAvg }}</span>
          </i-col>
          <i-col :md="6" style="height: 120px;padding-bottom: 10px;" v-if="homeStat.blackTrade.nightTradeList">
            <h3>夜间交易
              <InfoPopTip content="统计口径:晚上24点到早上5点之间交易的相关,辅助判断客户是否存在黄赌毒情况"/>
            </h3>
            <h2>¥{{ homeStat.blackTrade.nightTradeList.money }}元</h2>
            <span>次数:{{ homeStat.blackTrade.nightTradeList.countData }},天数:{{ homeStat.blackTrade.nightTradeList.dayAvg }}</span>
          </i-col>
        </Row>
        <Row :gutter="20" shadow style="padding-left: 40px;padding-top: 20px">
          <WordCloudMap style="height: 300px;width: 100%;" :value="stat.wordCloudData" ref="wordcloudmap"/>
        </Row>
      </i-col>
      <i-col :md="12" style="align-content: center">
        <Card shadow>
          <SmoothLine style="height: 380px;" :value="stat.incomingList" text="收入月度走势" ref="incomingListLine"/>
        </Card>
        <Card shadow>
          <SmoothLine style="height: 380px;" :value="stat.payoutList" text="支出月度走势" ref="payoutListLine"/>
        </Card>
        <Card shadow>
          <chart-bar style="height: 380px;" :x="barData.x" :y="barData.y" text="24小时交易分布" ref="charbar"/>
        </Card>
      </i-col>
    </Row>
    <Row>
      <Col span="6">
        <chart-pie style="height: 250px;" :value="stat.tradePieData" text="交易占比" ref="tradePie"></chart-pie>
      </Col>
      <Col span="6">
        <chart-pie style="height: 250px;" :value="stat.payoutPieData" text="支出类型占比" ref="payoutPie"></chart-pie>
      </Col>
      <Col span="6">
        <chart-pie style="height: 250px;" :value="stat.incomingPieData" text="收入类型占比"
                   ref="incomingPie"></chart-pie>
      </Col>
      <Col span="6">
        <chart-pie style="height: 250px;" :value="stat.consumeSubTypePieData" text="消费子类占比"
                   ref="consumeSubTypePie"></chart-pie>
      </Col>
    </Row>
    <Card shadow v-if="dataMap.bank_balance_list.length > 0">
      <SmoothLine style="height: 300px;" :value="stat.balanceList" text="银行卡余额走势图" ref="balanceListLine"/>
    </Card>
    <Card shadow v-if="dataMap.monthlySummaryList.length > 0">
      <ChartTableBar style="height: 300px;" :value="dataMap.monthlySummaryList" text="月度交易数据"
                     :series="monthlySummaryBar" ref="monthlySummaryBar"/>
    </Card>
  </div>
</template>
<script>
import { ChartBar, ChartPie, ChartTableBar, ProgressRing, SmoothLine, WordCloudMap } from '_c/charts'
import { InfoPopTip, InforCard } from '_c/info-card'
import CountTo from '_c/count-to'

export default {
  name: 'content-data-report',
  components: {
    ChartTableBar,
    ProgressRing,
    InforCard,
    ChartBar,
    CountTo,
    WordCloudMap,
    InfoPopTip,
    SmoothLine,
    ChartPie
  },
  props: {
    stat: Object,
    homeStat: Object,
    dataMap: Object,
    score: Object,
    barData: Object
  },
  data () {
    return {
      colSpan: 12,
      monthlySummaryBar: {
        x: 'statDesc',
        y: [{
          name: '收入',
          key: 'income'
        }, {
          name: '支出',
          key: 'payout'
        }, {
          name: '其他',
          key: 'other'
        }]
      }
    }
  },
  mounted: function () {
    this.setData(this.$parent.dataMap, this.$parent.homeStat, this.$parent.stat, this.$parent.score, this.$parent.barData)
  },
  methods: {
    setData (dataMap, homeStat, stat, score, barData) {
      this.dataMap = dataMap
      this.stat = stat
      this.homeStat = homeStat
      this.score = score
      this.barData = barData
    }
  }
}
</script>
<style lang="less" scoped>
.count-style {
  font-size: 30px;
}
</style>
